// src/components/WParkWaitlist.js
import React, { useState } from 'react';
import './WParkWaitlist.css';

const WParkWaitlist = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interest: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(
        "https://default1dab1bb71ea445ea86fa22fc43c52b.3d.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/dbd7572975f3447c8d521d6090468026/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=qDlMACTknSfjYU96PcXu2YdC8L1X-wUzmHheohqyFbE",
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        }
      );

      if (res.ok) {
        setSubmitted(true);
        setFormData({ name: '', email: '', interest: '' });
      } else {
        alert('❌ Submission failed. Please try again later.');
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      alert('⚠️ Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="wpark-waitlist-section">
      <h2 className="waitlist-heading">Get Early Access to WPark</h2>
      <p className="waitlist-subtext">
        Join the smarter mobility revolution. Be the first to park with presence-based precision.
      </p>

      {submitted ? (
        <p className="waitlist-thankyou">
          ✅ You’re on the list! We’ll notify you when WPark launches in your city.
        </p>
      ) : (
        <form className="waitlist-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <select name="interest" value={formData.interest} onChange={handleChange} required>
            <option value="" disabled>
              I'm interested as a...
            </option>
            <option value="driver">Driver</option>
            <option value="car park operator">Enterprise/ Car Park Operator</option>
            <option value="investor">Investor</option>
          </select>
          <button type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Join Waitlist'}
          </button>
        </form>
      )}
    </section>
  );
};

export default WParkWaitlist;
